module.exports = __webpack_public_path__ + "img/Arvostettu-Jallu-Mestari.c64f8fc7.png";